export default {
    SET_LOGIN: (state, {user_detail}) => (state.user = user_detail,state.permission=user_detail && user_detail.groups? user_detail.groups : null),
    SET_PLAN_INFO:(state,{plan})=>(state.plan_info=plan),
    SET_PERMISSION:(state,{permission})=>(state.permission=permission),
}
